import { Component, OnDestroy, OnInit } from '@angular/core';
import { ApkService } from 'app/be-api';
import { environment } from 'environments/environment';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-download-apk',
  templateUrl: './download-apk.component.html',
  styleUrls: ['./download-apk.component.scss']
})
export class DownloadApkComponent implements OnInit, OnDestroy {

  private unsubscribeAll: Subject<any>;
  constructor(
    private toastr: ToastrService,
    private apkService : ApkService
  ) { this.unsubscribeAll = new Subject();}

  @BlockUI() blockUI: NgBlockUI;

  ngOnInit(): void {
  }


  // downloadAndroidApk() {
  //   this.blockUI.start();
  //   this.apkService.apiVversionEcollectApkDownloadApkGet(environment.apiVersion)
  //     .pipe(takeUntil(this.unsubscribeAll))
  //     .subscribe((response: any) => {
  
  //       const blob = new Blob([response], {
  //         type: 'application/vnd.android.package-archive'
  //       });
  
  //       const url = window.URL.createObjectURL(blob);
  //       const a = document.createElement('a');
  //       a.href = url;
  //       a.download = "sidc-e-collect-mobile.apk";
  //       a.click();
  //       window.URL.revokeObjectURL(url);
  //     });

  //     this.blockUI.stop();
  // }

  downloadAndroidApk() {
    this.blockUI.start();
  
    this.apkService.apiVversionEcollectApkDownloadApkGet(environment.apiVersion)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (response: any) => {
          const blob = new Blob([response], {
            type: 'application/vnd.android.package-archive'
          });
  
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = "sidc-e-collect-mobile.apk";
          a.click();
          window.URL.revokeObjectURL(url);
        },
        error: (err) => {
          this.toastr.error('APK download failed', err, {
            timeOut: 3000,
            positionClass: 'toast-bottom-center',
            toastClass: 'toast ngx-toastr',
          });
          this.blockUI.stop(); 
        },
        complete: () => {
          this.blockUI.stop(); 
        }
      });
  } 
  
  ngOnDestroy(): void {
    this.unsubscribeAll.next();
    this.unsubscribeAll.complete();
  }

  

}
